import React, { useState } from 'react';
import { Box, Grid, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { FileDownloadOutlined } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';

const MdsDownload = () => {
  const [selectedPatient, setSelectedPatient] = useState<string>('Patient');
  const [selectedAssessmentType, setSelectedAssessmentType] = useState<string>('Assessment Type');
  const [selectedARD, setSelectedARD] = useState<Date>(new Date());
  const [downloadLoading, setDownloadLoading] = useState<boolean>(false);

  const handleDownload = () => {
    setDownloadLoading(true);
    // Simulate download process
    setTimeout(() => {
      setDownloadLoading(false);
    }, 2000);
  };

  return (
    <Box>
      <Grid 
        container 
        spacing={2} 
        alignItems="flex-end"
      >
        <Grid item>
          <TextField
            select
            value={selectedPatient}
            onChange={(e) => setSelectedPatient(e.target.value)}
            variant="outlined"
            size="small"
            sx={{ minWidth: 150 }}
            SelectProps={{
              native: true,
            }}
          >
            <option value="Patient">Patient</option>
            <option value="All Patients">All Patients</option>
          </TextField>
        </Grid>

        <Grid item>
          <TextField
            select
            value={selectedAssessmentType}
            onChange={(e) => setSelectedAssessmentType(e.target.value)}
            variant="outlined"
            size="small"
            sx={{ minWidth: 150 }}
            SelectProps={{
              native: true,
            }}
          >
            <option value="Assessment Type">Assessment Type</option>
            <option value="Start of Care">Start of Care</option>
            <option value="Resumption of Care">Resumption of Care</option>
            <option value="Recertification">Recertification</option>
            <option value="Discharge">Discharge</option>
          </TextField>
        </Grid>

        <Grid item>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              value={selectedARD}
              onChange={(date) => setSelectedARD(date || new Date())}
              maxDate={new Date()}
              slotProps={{
                textField: {
                  fullWidth: true,
                  variant: 'outlined',
                  size: 'small',
                  sx: { minWidth: 150 },
                  label: 'ARD'
                },
              }}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item>
          <LoadingButton
            disabled={downloadLoading}
            startIcon={<FileDownloadOutlined />}
            variant="contained"
            size="small"
            sx={{
              whiteSpace: 'nowrap',
              height: 35,
              width: 120,
              ':hover': {
                background: '#6366F1',
              },
              '.MuiLoadingButton-loadingIndicator': {
                left: 15,
              },
            }}
            loadingPosition="start"
            onClick={handleDownload}
            loading={downloadLoading}
          >
            Download
          </LoadingButton>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MdsDownload;
